import gql from 'graphql-tag';

export const albumForJoinTypeCheck = gql`
  query albumForJoinTypeCheck($id: RecordID!) {
    album(id: $id) {
      id
      album_folder {
        id
        join_type
        picture_day_enabled
      }
    }
  }
`;
